module.exports = __webpack_public_path__ + "59f2c668cb8c03fd99410c2ae6dfe65b.png";